<template>
  <Loader :show="loading" v-if="loading" />
  <div v-if="content.length > 0 && !loading">
    <MDBRow class="mb-1" v-for="(item, index) in content" :key="index">
      <MDBCol col="12">
        <div class="sub-title text-uppercase">
          <span class="text-uppercase text-danger">/
            {{ index + 1 }}</span>&nbsp;<span v-if="showPlusWord"
            class="text-uppercase text-danger">PLUS:</span>&nbsp;<span class="text-dark-gray"
            v-html="item.title[storedLocale]"></span>
        </div>

        <div v-html="item.description[storedLocale]"></div>
        <div
          v-if="item.action_link && item.action_link[storedLocale] && item.action_text && item.action_text[storedLocale]"
          class="d-flex justify-content-center align-items-center">
          <a class="btn btn-danger text-uppercase text-white" :href="item.action_link[storedLocale]">{{
            item.action_text[storedLocale]
          }}</a>
        </div>
      </MDBCol>
    </MDBRow>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import Loader from "@/components/General/Loader/index.vue";
import { computed } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
const store = useStore();
const { tenantConfig } = useTenantConfig();

store.dispatch("loadAboutPage");

const content = computed(() => store.getters.getAboutPage)
const loading = computed(() => store.getters.getPending);
const storedLocale = computed(() => store.getters.getCurrentLocale);
const showPlusWord = computed(() => tenantConfig.value?.showPlusWord ?? false);
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.sub-title {
  font-size: 20px;
  font-weight: 700;
}
</style>
